import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Backdrop from '../components/motion/Backdrop';
import Eyebrow from '../components/motion/Eyebrow';
import KineticHeadline from '../components/motion/KineticHeadline';
import Reveal from '../components/motion/Reveal';
import Claws from '../components/motion/Claws';
import '../styles/marketing.css';
import { HIDE_MONEY } from '../utils/platform';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is Pick 'N Pray?",
      answer: "Pick 'N Pray is a private pick'em platform for MMA events. Create or join pools with friends, make your fight predictions, and compete for bragging rights."
    },
    {
      question: "How do I create a pool?",
      answer: HIDE_MONEY
        ? "After signing up and logging in, click 'Create Pool' from your dashboard. Set your pool name, description and scoring rules. You'll get an invite code to share with friends."
        : "After signing up and logging in, click 'Create Pool' from your dashboard. Set your pool name, optional entry fee, and description. You'll get an invite code to share with friends."
    },
    {
      question: "How do I join a pool?",
      answer: "Get an invite code from the pool commissioner. Click 'Join Pool' and enter the code. You'll see a preview of the pool before confirming."
    },
    {
      question: "How does scoring work?",
      answer: "A correct winner earns 5 points on the main card, 3 on the prelims and 1 on the early prelims. If your pool requires a method, calling the method of victory (KO/TKO, Submission, Decision) correctly adds a bonus (3 points by default, set by the commissioner). Title fights can be worth more if the pool uses a championship multiplier."
    },
    {
      question: "When do I need to submit my picks?",
      answer: "Picks must be submitted before the event starts. Once an event is locked (typically when the first fight begins), you can no longer change your picks."
    },
    {
      question: "Can I be in multiple pools?",
      answer: "Yes! You can join as many pools as you want and compete with different groups of friends."
    },
    ...(HIDE_MONEY ? [] : [{
      question: "How do entry fees work?",
      answer: "Entry fees are handled outside the app between pool members. The commissioner tracks who has paid. Pick 'N Pray doesn't process any payments - it's just for tracking."
    }]),
    {
      question: "I forgot my password. What do I do?",
      answer: HIDE_MONEY
        ? "Currently, password reset isn't available (we're working on it!). For now, create a new account and ask your commissioner for a fresh invite."
        : "Currently, password reset isn't available (we're working on it!). For now, create a new account and let your commissioner know to mark you as paid if needed."
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="pnp-faq-page pnp-mkt pnp-embed">
      <section className="pnp-page-hero">
        <Backdrop glow="right" />
        <div className="pnp-wrap" style={{ maxWidth: 880 + 48 }}>
          <Eyebrow>FAQ</Eyebrow>
          <KineticHeadline as="h1" className="pnp-display pnp-h2" text={'Frequently asked\n*questions.*'} />
          <Reveal delay={200}>
            <p className="pnp-lead">Everything you need to know about Pick &apos;N Pray</p>
          </Reveal>
        </div>
      </section>

      <div className="pnp-wrap">
        <div className="pnp-faq">
          <ul className="pnp-faq-list">
            {faqs.map((faq, index) => {
              const open = openIndex === index;
              return (
                <Reveal as="li" key={index} delay={Math.min(index, 6) * 50} className={`pnp-faq-item pnp-glass${open ? ' is-open' : ''}`}>
                  <button
                    type="button"
                    className="pnp-faq-q"
                    onClick={() => toggleFaq(index)}
                    aria-expanded={open}
                    aria-controls={`pnp-faq-a-${index}`}
                    id={`pnp-faq-q-${index}`}
                  >
                    <span className="pnp-faq-n" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
                    <span>{faq.question}</span>
                    <span className="pnp-faq-plus" aria-hidden="true" />
                  </button>
                  <div className="pnp-faq-a" id={`pnp-faq-a-${index}`} role="region" aria-labelledby={`pnp-faq-q-${index}`} aria-hidden={!open}>
                    <div>
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </ul>

          <Reveal className="pnp-glass pnp-glass-red pnp-faq-cta">
            <Claws className="pnp-faq-claws" style={{ '--claw-w': '8px', '--claw-gap': '18px', right: '8%', top: '-20%', height: '140%', opacity: 0.35 }} />
            <h2 className="pnp-display pnp-h3">Ready to get started?</h2>
            <p className="pnp-body">Create your free account, then join the Title Shot or start a pool with your crew.</p>
            <div className="pnp-faq-cta-row">
              <Link to="/register" className="pnp-btn pnp-btn-primary">
                Create account <span className="pnp-btn-arrow" aria-hidden="true">→</span>
              </Link>
              <Link to="/join/TITLESHOT" className="pnp-btn pnp-btn-ghost">Join the Title Shot</Link>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
